'use client';

import { c as _c } from "react/compiler-runtime";
import { useTheme } from 'next-themes';
import { cn } from '@/lib/utils';
import { startThemeTransition } from '@/lib/theme-transition';
type props = {
  className?: string;
  children?: React.ReactNode;
};
export const AnimatedThemeToggler = t0 => {
  const $ = _c(9);
  const {
    className,
    children
  } = t0;
  const {
    resolvedTheme,
    setTheme
  } = useTheme();
  let t1;
  if ($[0] !== resolvedTheme || $[1] !== setTheme) {
    t1 = e => {
      startThemeTransition(() => setTheme(resolvedTheme === "dark" ? "light" : "dark"), e);
    };
    $[0] = resolvedTheme;
    $[1] = setTheme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const changeTheme = t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn("flex items-center justify-center", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== changeTheme || $[6] !== children || $[7] !== t2) {
    t3 = <button type="button" aria-label="Toggle theme" onClick={changeTheme} className={t2}>{children}</button>;
    $[5] = changeTheme;
    $[6] = children;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};